import i18next from "i18next"

export const DEFAULT_CURRENCY_CODE = "SAR"

export const getCurrencyLabel = (currencyCode = DEFAULT_CURRENCY_CODE) => {
  if (currencyCode === DEFAULT_CURRENCY_CODE) {
    return i18next.t("SAR", { defaultValue: DEFAULT_CURRENCY_CODE })
  }
  return currencyCode
}

export const formatCurrencyAmount = (
  amount,
  currencyCode = DEFAULT_CURRENCY_CODE
) => {
  const value = Number(amount ?? 0)
  const formatted = Number.isFinite(value) ? value.toLocaleString() : "0"
  const label = getCurrencyLabel(currencyCode)
  const isArabic = ["sa", "ar"].includes(i18next.language)
  return isArabic ? `${formatted} ${label}` : `${label} ${formatted}`
}